// extracted by mini-css-extract-plugin
export default {"inputSmall":"styles-module--inputSmall--cle-p","textArea":"styles-module--textArea--BC+IX","toggleContainer":"styles-module--toggleContainer--R8KMu"};